import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ToastrService {
  private batteryToastrVisible = new BehaviorSubject<boolean>(false);
  batteryToastrVisible$ = this.batteryToastrVisible.asObservable();

  private toastSubject = new Subject<{title: string, message: string; type: string, icon: string, duration: number }>();
  
  showToast(title: string, message: string, type: string = 'info', icon: string = 'icon-info', duration: number = 3000) {
    this.toastSubject.next({title, message, type, icon, duration });
  }

  showSuccessToastr(message: string) {
    this.showToast("Успешно!", message, 'success', 'icon-done_all');
  }
  showErrorToastr(message: string) {
    this.showToast("Ошибка!", message, 'error', 'icon-error');
  }
  showWarningToastr(message:string) {
    this.showToast("Предупреждение!", message, 'warning', 'icon-warning');
  }
  showInfoToastr(message:string) {
    this.showToast("Информация", message, 'info', 'icon-info');
  }

  getToast() {
    return this.toastSubject.asObservable();
  }

  setBatteryToastrVisible(visible: boolean) {
    this.batteryToastrVisible.next(visible);
  }
}
